import { matchPath } from 'react-router-dom';
import { delay, put } from 'redux-saga/effects';

import { vsuiteRoutes } from '@routes';
import { unreadMessageCountRequestAction } from '@store/user/user.actions';

export const pollUnreadMessagesSaga = function* () {
  while (true) {
    const isMessagesSection = !!matchPath(window.location.pathname, {
      path: vsuiteRoutes.MESSAGES.rule,
    });

    if (!isMessagesSection) {
      yield put(unreadMessageCountRequestAction());
    }

    yield delay(1000 * 60 * 5); // Debounce

    // Break loop in unit tests
    if (process.env.NODE_ENV === 'test') {
      break;
    }
  }
};
